import { uiState } from '@/types/field'
import { createSlice } from '@reduxjs/toolkit'

const initialState: uiState = {
    title: '',
    pageTitle: '',
    mainTitle: '',
    mainSlug: '',
    subTitle: ''
}

const uiSlice = createSlice({
    name: 'ui',
    initialState: initialState,
    reducers: {
        setDocumentTitle: (state, action) => {
            state.title = action.payload
            document.title = action.payload
        },
        setPageTitle: (state, action) => {
            state.pageTitle = action.payload
            state.mainTitle = ''
        },
        setMainTitle: (state, action) => {
            state.mainTitle = action.payload
        },
        setMainSlug: (state, action) => {
            state.mainSlug = action.payload
        },
        setSubTitle: (state, action) => {
            state.subTitle = action.payload
        }

    }
})

export const { setDocumentTitle, setPageTitle, setMainTitle, setMainSlug, setSubTitle } = uiSlice.actions

export default uiSlice.reducer

